import { CreatedOnCellWrapper } from './CreatedOnCell.styled';
import { TableBodyCell } from '../../../../../MyTickets.styled';
import { CreatedOnCellProps } from './CreatedOnCell.types';
import { formatDate } from 'src/utils/dateFns/formatDate';
import { getTimeAM_PM } from 'src/utils/dateFns/formatTime';

export const CreatedOnCell = ({ createdOn }: CreatedOnCellProps) => {
  const { month, day, year } = formatDate(new Date(createdOn));
  const { hour, minutes, am_pm } = getTimeAM_PM(new Date(createdOn));

  return (
    <TableBodyCell>
      <CreatedOnCellWrapper>
        <span>{`${month}/${day}/${year} `}</span>
        <span>{`${hour}:${minutes} ${am_pm}`}</span>
      </CreatedOnCellWrapper>
    </TableBodyCell>
  );
};
